import React from "react";
import Login from "../components/login/Login";

export default () => <Login/>